import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined'
import { motion, AnimatePresence } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useChatNotifStore, type ChatNotification } from '../store/chatNotificationStore'

export function ChatNotificationHost() {
  const items = useChatNotifStore((s) => s.items)

  return (
    <Box sx={{ position: 'fixed', top: 24, right: 24, zIndex: 2000, display: 'flex', flexDirection: 'column', gap: 1, maxWidth: 380 }}>
      <AnimatePresence>
        {items.map((n) => <ChatNotifCard key={n.id} notif={n} />)}
      </AnimatePresence>
    </Box>
  )
}

function ChatNotifCard({ notif }: { notif: ChatNotification }) {
  const navigate = useNavigate()
  const dismiss = useChatNotifStore((s) => s.dismiss)

  function handleClick() {
    dismiss(notif.id)
    navigate(`/chats/${notif.conversationId}`)
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -20, scale: 0.95 }}
      transition={{ duration: 0.25, ease: [0.32, 0.72, 0, 1] }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} onClick={handleClick}
        sx={{
          px: 2, py: 1.5, borderRadius: 2.5, cursor: 'pointer',
          bgcolor: 'background.paper',
          border: '1px solid', borderColor: 'divider',
          boxShadow: '0 8px 32px -8px rgba(0,0,0,0.18), 0 2px 8px -2px rgba(0,0,0,0.08)',
          transition: 'transform 0.15s, box-shadow 0.15s',
          '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 12px 40px -8px rgba(0,0,0,0.22)' },
          minWidth: 280,
        }}>
        <Avatar sx={{ width: 38, height: 38, bgcolor: notif.senderColor, fontSize: 13, fontWeight: 700 }}>
          {notif.senderInitials}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" alignItems="center" spacing={0.75}>
            <Typography sx={{ fontSize: 13, fontWeight: 700 }}>{notif.senderName}</Typography>
            <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 12, color: 'primary.main' }} />
          </Stack>
          <Typography sx={{ fontSize: 12.5, color: 'text.secondary', mt: 0.15 }} noWrap>{notif.text}</Typography>
        </Box>
        <IconButton size="small" onClick={(e) => { e.stopPropagation(); dismiss(notif.id) }}
          sx={{ color: 'text.disabled', flexShrink: 0, '&:hover': { color: 'text.secondary' } }}>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Stack>
    </motion.div>
  )
}
